
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class CanBeSizedMixin extends Vue {
  @Prop({ default: false })
  public small!: boolean;

  public get Size() {
    return this.small ? 'XXS' : 'XS';
  }
  public get SizeClass() {
    return this.small ? 'small' : 'normal';
  }
}
